import DisposableCameraPage from "../unAuthGuests/dispoCam";

export default function AdminDispocam() {
    return (
        <DisposableCameraPage />
    )
}